import React from 'react'
import { Box, Typography, Divider, FormLabel, FormControlLabel, Checkbox, TextField, MenuItem, Alert } from '@mui/material'
import SelectList from '../../../../../Components/Elements/SelectList'
import NivoSchemeSelector from '../../../../../Components/Form/NivoSchemeSelector'
import { BlockSettingsProps } from './types'

export const CountLinkOptionsSettings: React.FC<BlockSettingsProps> = ({ kedo, state, handleChangeSettings }) => {
    if (!state.item.defDossier) return <Alert severity="info">{kedo.t('Select an Entity first')}</Alert>
    return (
        <Box sx={{ mt: 2 }}>
            <Typography variant="h6">{kedo.t('Date options')}</Typography>
            <Box sx={{ mt: 2 }}>
                <FormLabel>
                    {kedo.t('Date')} <Typography variant="caption">{kedo.t('Optional')}</Typography>
                </FormLabel>
                <SelectList
                    disableInit={true}
                    currentValue={state.item.settings.date_field}
                    onClear={() => handleChangeSettings('date_field', null)}
                    searchName={'search'}
                    kedo={kedo}
                    urlParams={{
                        type: 'date',
                        environment: kedo.env().getEnvironment().id,
                        defDossier: state.item.defDossier,
                    }}
                    onDisplayName={(item: any) => item.name}
                    url={kedo.api().getDefDossierDefFieldEndpoint()}
                    onSelect={(item: any) => {
                        handleChangeSettings('date_field', item.id)
                    }}
                />
            </Box>
            <FormControlLabel
                control={
                    <Checkbox
                        checked={state.item.settings.use_creation_date === true}
                        onChange={(e) => {
                            handleChangeSettings('use_creation_date', e.target.checked)
                        }}
                    />
                }
                label={`${kedo.t('Use dossier creation date')} ${kedo.t('Optional')}`}
                sx={{ mt: 2 }}
            />
            <Divider sx={{ my: 2 }} />
            <Typography variant="h6" sx={{ mb: 2 }}>
                {kedo.t('Origin options')}
            </Typography>
            <Box sx={{ mt: 2 }}>
                <FormLabel>{kedo.t('Origin display link field')}</FormLabel>
                <SelectList
                    key={`origin_link_field`}
                    disableInit={true}
                    currentValue={state.item.settings.origin_link_field}
                    onClear={() => handleChangeSettings('origin_link_field', null)}
                    searchName={'search'}
                    kedo={kedo}
                    urlParams={{
                        page: 0,
                        limit: 200,
                        environment: kedo.env().getEnvironment().id,
                        defDossier: state.item.defDossier,
                    }}
                    onDisplayName={(item: any) => item.name}
                    url={kedo.api().getDefDossierLinkEndpoint()}
                    onUpdateCurrentItem={(item: any) => handleChangeSettings('origin_link_field', item.child_def_dossier_id)}
                    onSelect={(item: any) => {
                        handleChangeSettings('origin_link_field', item.id)
                    }}
                />
            </Box>
            <Box sx={{ mt: 2 }}>
                <FormLabel>{kedo.t('Origin display field')}</FormLabel>
                <SelectList
                    key={`link_display_field`}
                    currentValue={state.item.settings.origin_display_field}
                    onClear={() => handleChangeSettings('origin_display_field', null)}
                    disableInit={true}
                    searchName={'search'}
                    kedo={kedo}
                    urlParams={{
                        defDossier: state.originLinkDefDossier ? state.originLinkDefDossier : state.item.defDossier,
                    }}
                    onDisplayName={(item: any) => item.name}
                    url={kedo.api().getDefDossierDefFieldEndpoint()}
                    onSelect={(item: any) => handleChangeSettings('origin_display_field', item.id)}
                />
            </Box>
            <Divider sx={{ my: 2 }} />
            <Typography variant="h6" sx={{ mb: 2 }}>
                {kedo.t('Link options')}
            </Typography>
            <Box sx={{ mt: 2 }}>
                <FormLabel className={'required'}>{kedo.t('Link field')}</FormLabel>
                <SelectList
                    key={`count_link_field`}
                    currentValue={state.item.settings.count_link_field}
                    onClear={() => handleChangeSettings('count_link_field', null)}
                    searchName={'search'}
                    kedo={kedo}
                    urlParams={{
                        page: 0,
                        limit: 200,
                        environment: kedo.env().getEnvironment().id,
                        defDossier: state.item.defDossier,
                    }}
                    onDisplayName={(item: any) => item.name}
                    url={kedo.api().getDefDossierLinkEndpoint()}
                    onUpdateCurrentItem={(item: any) => {
                        handleChangeSettings('count_link_field', item.child_def_dossier_id)
                    }}
                    onSelect={(item: any) => {
                        handleChangeSettings('count_link_field', item.id)
                    }}
                />
            </Box>
            {state.countLinkDefDossier ? (
                <Box sx={{ mt: 2 }}>
                    <FormLabel>{kedo.t('Second link field')}</FormLabel>
                    <SelectList
                        key={`count_link_field_sec`}
                        disableInit={true}
                        currentValue={state.item.settings.count_link_field_sec}
                        onClear={() => handleChangeSettings('count_link_field_sec', null)}
                        searchName={'search'}
                        kedo={kedo}
                        urlParams={{
                            page: 0,
                            limit: 200,
                            environment: kedo.env().getEnvironment().id,
                            defDossier: state.countLinkDefDossier,
                        }}
                        onDisplayName={(item: any) => item.name}
                        url={kedo.api().getDefDossierLinkEndpoint()}
                        onUpdateCurrentItem={(item: any) => {
                            handleChangeSettings('count_link_field_sec', item.child_def_dossier_id)
                        }}
                        onSelect={(item: any) => {
                            handleChangeSettings('count_link_field_sec', item.id)
                        }}
                    />
                </Box>
            ) : null}
            <NivoSchemeSelector
                kedo={kedo}
                value={state.item.settings.scheme}
                onChange={(e: any) => handleChangeSettings('scheme', e.target.value)}
                sx={{ mt: 2 }}
            />
            {state.countLinkDefDossier || state.countLinkDefDossierSec ? (
                <Box sx={{ mt: 2 }}>
                    <FormLabel>{kedo.t('Link display field')}</FormLabel>
                    <SelectList
                        key={`link_display_field`}
                        currentValue={state.item.settings.link_display_field}
                        onClear={() => handleChangeSettings('link_display_field', null)}
                        disableInit={true}
                        searchName={'search'}
                        kedo={kedo}
                        urlParams={{
                            defDossier: state.countLinkDefDossierSec ? state.countLinkDefDossierSec : state.countLinkDefDossier,
                        }}
                        onDisplayName={(item: any) => item.name}
                        url={kedo.api().getDefDossierDefFieldEndpoint()}
                        onSelect={(item: any) => handleChangeSettings('link_display_field', item.id)}
                    />
                </Box>
            ) : null}
            <Divider sx={{ my: 2 }} />
            <TextField
                select
                size="small"
                fullWidth
                label={kedo.t('Date format')}
                value={state.item.settings.date_format || ''}
                onChange={(e) => handleChangeSettings('date_format', e.target.value)}
                margin="normal"
            >
                <MenuItem value="">{kedo.t('Choose an option')}</MenuItem>
                <MenuItem value="year_month">{kedo.t('Year month')}</MenuItem>
                <MenuItem value="quarter">{kedo.t('Quarters')}</MenuItem>
                <MenuItem value="year">{kedo.t('Year')}</MenuItem>
            </TextField>
            <TextField
                select
                size="small"
                fullWidth
                label={kedo.t('Chart format')}
                value={state.item.settings.chart_format || ''}
                onChange={(e) => handleChangeSettings('chart_format', e.target.value)}
                margin="normal"
            >
                <MenuItem value="">{kedo.t('Choose an option')}</MenuItem>
                <MenuItem value="line">{kedo.t('Line')}</MenuItem>
                <MenuItem value="bar">{kedo.t('Bar')}</MenuItem>
                <MenuItem value="pie">{kedo.t('Pie')}</MenuItem>
                <MenuItem value="table">{kedo.t('Table')}</MenuItem>
            </TextField>
            {state.item.settings.chart_format === 'bar' ? (
                <TextField
                    select
                    size="small"
                    fullWidth
                    label={kedo.t('Group format')}
                    value={state.item.settings.group_format || ''}
                    onChange={(e) => handleChangeSettings('group_format', e.target.value)}
                    margin="normal"
                >
                    <MenuItem value="">{kedo.t('Choose an option')}</MenuItem>
                    <MenuItem value="grouped">{kedo.t('Grouped')}</MenuItem>
                    <MenuItem value="stacked">{kedo.t('Stacked')}</MenuItem>
                </TextField>
            ) : null}
            {state.item.settings.chart_format === 'bar' ? (
                <TextField
                    select
                    size="small"
                    fullWidth
                    label={kedo.t('Chart layout')}
                    value={state.item.settings.chart_layout || ''}
                    onChange={(e) => handleChangeSettings('chart_layout', e.target.value)}
                    margin="normal"
                >
                    <MenuItem value="">{kedo.t('Choose an option')}</MenuItem>
                    <MenuItem value="vertical">{kedo.t('Vertical')}</MenuItem>
                    <MenuItem value="horizontal">{kedo.t('Horizontal')}</MenuItem>
                </TextField>
            ) : null}
            {state.item.settings.chart_format === 'table' ? (
                <TextField
                    select
                    size="small"
                    fullWidth
                    label={kedo.t('Table layout')}
                    value={state.item.settings.table_layout || ''}
                    onChange={(e) => handleChangeSettings('table_layout', e.target.value)}
                    margin="normal"
                >
                    <MenuItem value="">{kedo.t('Choose an option')}</MenuItem>
                    <MenuItem value="ver1">{kedo.t('Version 1 (Martinique header)')}</MenuItem>
                    <MenuItem value="ver2">{kedo.t('Version 2 (Dark header/green striped')}</MenuItem>
                    <MenuItem value="ver3">{kedo.t('Version 3 (Havelock Blue)')}</MenuItem>
                    <MenuItem value="ver4">{kedo.t('Version 4 (Red)')}</MenuItem>
                    <MenuItem value="ver5">{kedo.t('Version 5 (Dark header/light blue striped)')}</MenuItem>
                    <MenuItem value="ver6">{kedo.t('Version 6 (Purple)')}</MenuItem>
                </TextField>
            ) : null}
            {state.item.settings.chart_format === 'table' ? (
                <TextField
                    select
                    size="small"
                    fullWidth
                    label={kedo.t('Reverse axis')}
                    value={state.item.settings.reverse_axis || ''}
                    onChange={(e) => handleChangeSettings('reverse_axis', e.target.value)}
                    margin="normal"
                >
                    <MenuItem value="">{kedo.t('Choose an option')}</MenuItem>
                    <MenuItem value="no">{kedo.t('no')}</MenuItem>
                    <MenuItem value="yes">{kedo.t('yes')}</MenuItem>
                </TextField>
            ) : null}
            <TextField
                select
                size="small"
                fullWidth
                label={kedo.t('Show Y scrollbars')}
                value={state.item.settings.show_y_scroll || ''}
                onChange={(e) => handleChangeSettings('show_y_scroll', e.target.value)}
                margin="normal"
            >
                <MenuItem value="">{kedo.t('Choose an option')}</MenuItem>
                <MenuItem value="no">{kedo.t('no')}</MenuItem>
                <MenuItem value="yes">{kedo.t('yes')}</MenuItem>
            </TextField>
        </Box>
    )
}
